export interface JsonContractCgvType {
  id: string;
  name: string;
}

export class ContractCgvType {
  id: string;
  name: string;

  constructor(jsonContractCgvType: JsonContractCgvType = null) {
    if (jsonContractCgvType) {
      this.id = jsonContractCgvType.id;
      this.name = jsonContractCgvType.name;
    }
  }
}
